<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h630_dialog abow_dialog"
      width="1300px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="省区"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="城市"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="方案编号"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.schemeNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="方案名称"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.schemeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="活动日期"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.activityDate"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="最后审核时间"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.feedbackTime"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="人员名称"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.userName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="活动场次"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.fieldTypeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="是否有展陈"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.isDisplayValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="展陈数量"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.displayAmount"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="是否月度人员"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.isMonthValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="绩效金额"
                    required
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.performanceAmount"
                      :disabled="eventType === 'view'"
                      @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'performanceAmount')}"
                      @blur="setNumberValueDefaultZero($event, dialogAddEditViewForm, 'performanceAmount',2);totalAmountFun()"
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="扣除金额"
                    required
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.deductAmount"
                      :disabled="eventType === 'view'"
                      @input="(val)=>{limitNumber(val, dialogAddEditViewForm, 'deductAmount')}"
                      @blur="setNumberValueDefaultZero($event, dialogAddEditViewForm, 'deductAmount',2);totalAmountFun()"
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="实发绩效金额"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.realPerformanceAmount"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="绩效扣除说明"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.deductDescription"
                      :disabled="eventType === 'view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="是否计算绩效"
                    prop="isPerformance"
                  >
                    <el-radio-group
                      v-if="eventType==='edit'"
                      v-model="dialogAddEditViewForm.isPerformance"
                    >
                      <el-radio :label="1">
                        是
                      </el-radio>
                      <el-radio :label="2">
                        否
                      </el-radio>
                    </el-radio-group>
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.isPerformanceValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// API
import { viewSalaryActivityPerformanceInfoApi, saveSalaryActivityPerformanceInfoApi } from '@/api/v2/salaryActivityPerformanceInfo'

export default {
  components: {},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        isPerformance: [{ required: true, message: '请选择是否计算绩效', trigger: 'change' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }]
      }
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;

        _this.loading = true

        _this.dialogAddEditViewForm = {}
        _this.loadData()

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    loadData () {
      let _this = this
      viewSalaryActivityPerformanceInfoApi({ id: _this.dataId }).then(res => {
        const { data } = res
        _this.dialogAddEditViewForm = data
        if(_this.dialogAddEditViewForm.isPerformance === 0){
          _this.dialogAddEditViewForm.isPerformance = null
        }
        _this.loading = false
      })
    },
    totalAmountFun(){
      this.dialogAddEditViewForm.realPerformanceAmount = Number((Number(this.dialogAddEditViewForm.performanceAmount) - Number(this.dialogAddEditViewForm.deductAmount)).toFixed(2))
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      if(this.dialogAddEditViewForm.deductAmount !== 0 && this.dialogAddEditViewForm.deductDescription.trim().length === 0){
        this.$message({ message: '请输入扣除说明', type: 'warning' })
        return false
      }
      this.dialogAddEditViewForm.deductDescription = this.dialogAddEditViewForm.deductDescription.trim()
      this.totalAmountFun()
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            '是否确定调整是否计算绩效？', '系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              this.handlerSave()
            })
            .catch(() => { })
        }
      })
    },
    // 保存
    handlerSave() {
      let _this = this
      let params = {
        id: _this.dialogAddEditViewForm.id,
        sellId: _this.dialogAddEditViewForm.sellId,
        isPerformance: _this.dialogAddEditViewForm.isPerformance,
        performanceAmount: _this.dialogAddEditViewForm.performanceAmount,
        deductAmount: _this.dialogAddEditViewForm.deductAmount,
        realPerformanceAmount: _this.dialogAddEditViewForm.realPerformanceAmount,
        deductDescription: _this.dialogAddEditViewForm.deductDescription,
        remark: _this.dialogAddEditViewForm.remark
      }
      saveSalaryActivityPerformanceInfoApi(params).then(() => {
        _this.loading = false
        _this.$message({ message: '保存成功', type: 'success' })
        _this.reloadData()
        _this.modalClose()
      }).catch(() => {
        _this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
</style>
